import { render, staticRenderFns } from "./CaisseBillV2.vue?vue&type=template&id=1408eca0&"
import script from "./CaisseBillV2.vue?vue&type=script&lang=js&"
export * from "./CaisseBillV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports